import { observer } from 'mobx-react-lite';
import type { FC, ImgHTMLAttributes } from 'react';

import { QH } from '../../constants';
import { useAppStore } from '../../store/app';
import { getThemedAssetUrl } from '../../theme/effective-theme';

type BrandLogoVariant = 'logo' | 'logo-white';

type BrandLogoProps = {
  variant?: BrandLogoVariant;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> & {
    alt?: string;
  };

export const BrandLogo: FC<BrandLogoProps> = observer(({
  variant = 'logo',
  alt = QH,
  ...imgProps
}) => {
  const { layout } = useAppStore();
  const src = getThemedAssetUrl(layout, variant);

  return <img src={src} alt={alt} {...imgProps} />;
});

BrandLogo.displayName = 'BrandLogo';
